import React, { useContext } from "react";
import { HotelContext } from "../context/HotelContext";
import Translation from "../utils/Translation";
import lunicleanLogo from "../img/Logo_Luniclean.png";
import yesnomailLogo from "../img/yesnomail.png";

const labelFromCode = (s) => {
  // Si le texte n'est pas "LUNICLEAN" ou "YESNOMAIL", c'est déjà une traduction, on la retourne telle quelle
  if (s && s !== "LUNICLEAN" && s !== "YESNOMAIL" && !s.toUpperCase().includes("YESNOMAIL")) {
    return s;
  }
  // Sinon, on retourne le texte tel quel (sera géré par les traductions du backend)
  return s;
};

export default function DeclinedServiceCard({ number, refusedAt, services = [] }) {
  const { lang } = useContext(HotelContext);
  const locale = lang === "en" ? "en-US" : "fr-FR";
  
  // Sécurité: normaliser la structure attendue des services
  // - string -> { text: "LUNICLEAN" }
  // - object  -> { text, refusedAt }
  const normalized = Array.isArray(services)
    ? services.map((s) =>
        typeof s === "string" ? { text: s, refusedAt: null } : s
      )
    : [];

  // Tri optionnel (le plus récent en haut)
  normalized.sort((a, b) => {
    const ta = a?.refusedAt ? new Date(a.refusedAt).getTime() : 0;
    const tb = b?.refusedAt ? new Date(b.refusedAt).getTime() : 0;
    return tb - ta;
  });

  return (
    <div className="declined-card">
      {/* Colonne gauche : numéro de chambre */}
      <div className="declined-card-left">
        <div className="declined-room">
          <span className="declined-room-label">N°</span>
          <span className="declined-room-num">{number}</span>
        </div>
      </div>

      {/* Colonne droite : lignes service → heure à droite */}
      <div className="declined-lines">
        {normalized.map((service, idx) => {
          const text   = service?.text;
          const source = service?.source;
          const dt     = service?.refusedAt ? new Date(service.refusedAt) : null;
          const isYesNoMail = (typeof source === "string" && source.toUpperCase() === "YESNOMAIL")
            || (typeof text === "string" && text.toUpperCase().includes("YESNOMAIL"));
          const iconSrc = isYesNoMail ? yesnomailLogo : lunicleanLogo;

          const dateStr = dt
            ? dt.toLocaleDateString(locale, { day: "2-digit", month: "2-digit", year: "numeric" })
            : null;
          const timeStr = dt
            ? dt.toLocaleTimeString(locale, { hour: "2-digit", minute: "2-digit" })
            : null;

          return (
            <div key={idx + String(text)} className="declined-line">
              <span className="declined-badge">
                <img src={iconSrc} alt="" className="declined-badge-ic" />
                <span className="declined-badge-text">{labelFromCode(text)}</span>
              </span>

              {/* Heure/date alignées à droite */}
              {(dateStr || timeStr) && (
                <div className="declined-line-time">
                  <em>
                    {dateStr ? (
                      <>
                        <Translation tag="Declined_refused_on" /> {dateStr} <Translation tag="Declined_refused_at" /> {timeStr}
                      </>
                    ) : (
                      <>
                        <Translation tag="Declined_refused_only_time" /> {timeStr}
                      </>
                    )}
                  </em>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
